<template>
  <div>
    <v-dialog v-model="value" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab @click="onClose" small flat><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text>
          <div class="form-control">
            <div class="caption">ชื่อสาขา</div>
            <input v-model="branch.name" type="text" placeholder="ชื่อสาขา" />
          </div>

          <v-radio-group v-model="branch.type" row>
            <v-radio value="Workshop" label="ศูนย์บริการ" color="primary"></v-radio>
            <v-radio value="Retail" label="ร้านอะไหล่" color="primary"></v-radio>
          </v-radio-group>

          <div class="form-control">
            <div class="caption">ที่อยู่</div>
            <textarea v-model="branch.address" placeholder="ที่อยู่" outline></textarea>
          </div>

          <div class="form-control">
            <div class="caption">เบอร์โทร</div>
            <input v-model="branch.tel" type="text" placeholder="เบอร์โทร" />
            <div class="caption grey--text">Ex. 02-552-0961,085-055-6158</div>
          </div>

          <v-layout>
            <v-flex class="pr-1">
              <div class="form-control">
                <div class="caption">Latitude</div>
                <input v-model="branch.lat" type="text" placeholder="Latitude" />
              </div>
            </v-flex>
            <v-flex class="pl-1">
              <div class="form-control">
                <div class="caption">Longtitude</div>
                <input v-model="branch.long" type="text" placeholder="Longtitude" />
              </div>
            </v-flex>
          </v-layout>

          <div class="form-control">
            <div class="caption">เมือง</div>
            <input v-model="branch.city" type="text" placeholder="City" />
          </div>

          <div class="form-control">
            <div class="caption">ลิ้งค์</div>
            <textarea v-model="branch.link" placeholder="Link" outline></textarea>
            <div class="caption grey--text">Ex. https://www.google.com</div>
          </div>

          <div class="text-xs-center">
            <v-btn color="grey" outline @click="onClose">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'currentbranch'],
  data() {
    return {
      branch: {
        name: '',
        type: 'Workshop',
        address: '',
        tel: '',
        lat: '',
        long: '',
        cityid: 'CITY01',
        city: 'กรุงเทพมหานคร',
        link: ''
      }
    }
  },
  mounted() {
    if (this.currentbranch) {
      this.branch = this.currentbranch
    }
  },
  methods: {
    onClose() {
      this.branch = {
        name: '',
        type: 'Workshop',
        address: '',
        tel: '',
        lat: '',
        long: '',
        cityid: 'CITY01',
        city: 'กรุงเทพมหานคร',
        link: ''
      }
      this.$emit('input', false)
    },
    onSave() {
      this.$emit('onSave', this.branch)
      this.branch = {
        name: '',
        type: 'Workshop',
        address: '',
        tel: '',
        lat: '',
        long: '',
        cityid: 'CITY01',
        city: 'กรุงเทพมหานคร',
        link: ''
      }
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/ManageBranchLocation.vue